import React, { useState, useEffect, useContext } from "react";
import DataTable from 'react-data-table-component';
import { contentContext } from "../context/contentContext";
const ParticipantTable = ({ participantsReserved, filterType }) => {
    // const [selectedFilter, setSelectedFilter] = useState("");
    const [selectedFilter, setSelectedFilter] = useState(filterType || "registered");
    const [tableCurrentPage, setTableCurrentPage] = useState(1);
    const [tableRowsPerPage, setTableRowsPerPage] = useState(10);
    const { data, GetTimeActivity } = useContext(contentContext)

    const getFilteredData = () => {
        const allData = participantsReserved?.data || [];

        if (selectedFilter === "participated") {
            return allData.filter(item => item.participated);
        } else if (selectedFilter === "registered") {
            return allData.filter(item => item.reserverdon);
        }


        return allData;
    };

    console.log('getFilteredData', getFilteredData())

    const handlePageChange = (page) => {
        GetTimeActivity()
        setTableCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()
        setTableRowsPerPage(newPerPage);
    };
    const conditionalRowStyles = [
        {
            when: row => row.participated === true,
            classNames: ['participated'],
        },
    ];

    const columns = [

        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.emailid,
            sortable: true,
        },
        {
            name: selectedFilter === "participated"
                ? "Participated On"
                : "Registered On",

            selector: row =>
                selectedFilter === "participated"
                    ? row.participatedEndTime
                    : row.reserverdon,

            cell: row => {
                const value =
                    selectedFilter === "participated"
                        ? row.participatedEndTime
                        : row.reserverdon;

                if (!value) return '-';

                const date = new Date(value);
                // ✅ Prevent NaN display
                if (isNaN(date.getTime())) return '-';

                return (
                    String(date.getDate()).padStart(2, '0') + '-' +
                    String(date.getMonth() + 1).padStart(2, '0') + '-' +
                    date.getFullYear() + ', ' +
                    String(date.getHours()).padStart(2, '0') + ':' +
                    String(date.getMinutes()).padStart(2, '0')
                );
            },
            sortable: true,
        }


    ];
    const keyForRerender = `${tableRowsPerPage}_${data?.length}`;
    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No participants found</p>
                </div> </div>
        )
    }
    console.log('filter', filterType)
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            const aField = String(selector(rowA) || '').toLowerCase();
            const bField = String(selector(rowB) || '').toLowerCase();

            let comparison = 0;
            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        return sortedData; // ✅ RETURN THE SORTED ARRAY
    };

    return (

        <div className="row table-data participated-table" id="table-data-row">
            <div className="col-12">
                <div className="card-body p-2" id="card-body">
                    <div className="row mb-2" id="table-header-row">
                        <div className="col-lg-12 d-flex justify-content-end">
                            <div className="mb-2 d-inline-block" id="search-box">
                                <div className="row mb-2">
                                    <div className="col-12 ">
                                        {/* <select
                                            disabled={filterType === "participated"}
                                            className="form-select w-auto"
                                            value={filterType === "participated" ? "participated" : selectedFilter}
                                            onChange={(e) => setSelectedFilter(e.target.value)}
                                        >
                                            <option value="registered">Registered</option>
                                            <option value="participated">Participated</option>
                                        </select> */}
                                        <select
                                            className="form-select w-auto"
                                            value={selectedFilter}
                                            onChange={(e) => setSelectedFilter(e.target.value)}
                                        >
                                            <option value="registered">Registered</option>
                                            <option value="participated">Participated</option>
                                        </select>

                                    </div>
                                </div>
                            </div>
                            <div className="text-sm-end" id="text-end"></div>
                        </div>
                    </div>

                    <DataTable
                        className="participate-bg"
                        key={keyForRerender}
                        conditionalRowStyles={conditionalRowStyles}
                        columns={columns}
                        keyField='_id'
                        data={getFilteredData() || []}
                        direction="auto"
                        highlightOnHover
                        fixedHeaderScrollHeight="300px"
                        pagination
                        responsive
                        persistTableHead
                        striped
                        subHeaderAlign="right"
                        defaultSortField="name"
                        noDataComponent={customNoRecords()}

                        paginationTotalRows={getFilteredData()?.length || 0}

                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        paginationPerPage={tableRowsPerPage}
                        paginationDefaultPage={tableCurrentPage}
                        paginationRowsPerPageOptions={[10, 25, 50, 75, 100]}
                        sortFunction={customSort}
                        paginationComponentOptions={{
                            rowsPerPageText: 'Per page:',
                            rangeSeparatorText: 'of',
                            noRowsPerPage: false,
                            selectAllRowsItem: false,
                            selectAllRowsItemText: 'All',
                        }}
                        // progressPending={isLoading}

                        // progressComponent={<TableLoader />}
                        id="data-table"
                    />

                </div>
            </div>
        </div>

    );
};

export default ParticipantTable;
